import { ReactNode } from 'react';
import { Link } from 'react-router';

interface NavButtonProps {
  to: string;
  icon: ReactNode;
  label: string;
  isActive: boolean;
  currentPath: string;
  badge?: ReactNode;
  onClick?: () => void;
}

export const NavButton = ({
  to,
  icon,
  label,
  isActive,
  currentPath,
  badge,
  onClick,
}: NavButtonProps) => {
  const isActiveRoute = isActive && currentPath === to;

  return (
    <Link to={to} className="group" onClick={onClick}>
      <div
        className={`w-60 h-9 px-2 py-5 rounded-xl inline-flex justify-start items-center gap-2 transition-all duration-300 ease-out cursor-pointer relative ${
          isActiveRoute
            ? 'bg-[#151717] shadow-[0px_0.375px_0.375px_0px_inset_rgba(255,255,255,0.17)]'
            : ''
        } hover:bg-[#151717] hover:shadow-[0px_0.375px_0.375px_0px_inset_rgba(255,255,255,0.17)]`}
      >
        <div className="flex justify-between items-center w-full">
          <div className="flex justify-start items-center gap-2.5">
            <div className="size-5 flex items-center justify-center">
              <div
                className={`w-5 h-5 fill-current transition-all duration-300 ease-out [&>svg]:w-full [&>svg]:h-full ${
                  isActiveRoute
                    ? 'text-white'
                    : 'text-[#96A3A3] group-hover:text-white'
                }`}
              >
                {icon}
              </div>
            </div>
            <div
              className={`justify-start text-sm font-medium font-['Inter'] leading-tight transition-all duration-300 ease-out ${
                isActiveRoute
                  ? 'text-white'
                  : 'text-[#96A3A3] group-hover:text-white'
              }`}
            >
              {label}
            </div>
          </div>
          {badge && <div>{badge}</div>}
        </div>
      </div>
    </Link>
  );
};
